define([], function () {
  let handlingElement = function () {
    this.element = null;
  }

  handlingElement.returnElement = (srcElement, options) => {
    if (srcElement != null) {
      let el = srcElement;
      while (el[options.key] !== options.value) {
        el = el.parentNode;
      }

      return el;
    }
  }

  handlingElement.removeClassFromElements = (els, className, onParent = false) => {
    if (els != null) {
      for (var i = 0; i < els.length; i++) {
        els[i].classList.remove(className);
      }
    }
  }

  handlingElement.removeClass = (el, className) => {
    if (el != null) {
      if (el.classList) {
        el.classList.remove(className);
      } else {
        el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
      }
      return el;
    }
  }

  handlingElement.addClass = (el, className) => {
    if (el != null) {
      if (el.classList) {
        el.classList.add(className);
      } else {
        el.className += ' ' + className;
      }
      return el;
    }
  }
  return handlingElement;
});
